// LIYAQAT theme scripts
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  var overlay = document.querySelector('[data-overlay]');
  function closeAll() {
    document.querySelectorAll('.drawer.open, .mobile-menu.open').forEach(function (d) { d.classList.remove('open'); });
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  function open(sel) {
    var el = document.querySelector(sel);
    if (!el) return;
    el.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('input[type=search]'); if (f) setTimeout(function () { f.focus(); }, 250);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target.hasAttribute('data-overlay')) { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Cart drawer refresh
  function refreshCart() {
    fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-drawer-inner]');
      var cur = document.querySelector('[data-cart-drawer-inner]');
      if (next && cur) cur.innerHTML = next.innerHTML;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('[data-bag-count]').forEach(function (el) {
          el.textContent = c.item_count; el.style.display = c.item_count > 0 ? 'flex' : 'none';
        });
      });
    });
  }
  window.liyaqatRefreshCart = refreshCart;

  // AJAX add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); open('[data-cart-drawer]'); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Cart quantity / remove (drawer + page)
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-change]');
    if (!q) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: q.dataset.key, quantity: parseInt(q.dataset.qty, 10) })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); }
      else { refreshCart(); }
    });
  });

  // Quantity selector
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + parseInt(b.dataset.qtyStep, 10));
  });

  // Gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (!t) return;
      g.querySelector('[data-main-image]').src = t.dataset.full;
      g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  // Recent searches
  var sform = document.querySelector('[data-search-form]');
  if (sform) {
    sform.addEventListener('submit', function () {
      var v = sform.querySelector('input[name=q]').value.trim();
      if (!v) return;
      var list = JSON.parse(localStorage.getItem('liyaqat_recent') || '[]');
      list = [v].concat(list.filter(function (x) { return x !== v; })).slice(0, 5);
      localStorage.setItem('liyaqat_recent', JSON.stringify(list));
    });
  }
  var recentWrap = document.querySelector('[data-recent]');
  if (recentWrap) {
    var list = JSON.parse(localStorage.getItem('liyaqat_recent') || '[]');
    if (list.length) {
      recentWrap.innerHTML = '<p class="eyebrow" style="margin-bottom:10px">Recent searches</p>' +
        list.map(function (t) { return '<a class="link-line" style="display:inline-block;margin:0 12px 12px 0" href="/search?q=' + encodeURIComponent(t) + '">' + t.replace(/</g, '&lt;') + '</a>'; }).join('');
    }
  }

  // Variant selection
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var form = sel.closest('form');
      form.querySelector('[name=id]').value = sel.value;
      var opt = sel.options[sel.selectedIndex];
      var priceEl = form.parentElement.querySelector('[data-price]');
      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  });
});
